import { useState, useEffect } from 'react'

interface GeoData {
  country: string
  countryCode: string
  city?: string
  flag?: string
  ip?: string
  latitude?: number
  longitude?: number
  region?: string
  timezone?: string
  org?: string
}

// Map of country codes to flag emojis
function countryCodeToFlag(code: string): string {
  const codePoints = code
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}

export function useGeoLocation() {
  const [geo, setGeo] = useState<GeoData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const cached = sessionStorage.getItem('belo_geo')
    if (cached) {
      try {
        setGeo(JSON.parse(cached))
        setLoading(false)
        return
      } catch {
        // ignore parse errors
      }
    }

    const controller = new AbortController()

    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then((res) => res.json())
      .then((data) => {
        if (data.country_name && data.country_code) {
          const geoData: GeoData = {
            country: data.country_name,
            countryCode: data.country_code,
            city: data.city || undefined,
            flag: countryCodeToFlag(data.country_code),
            ip: data.ip || undefined,
            latitude: data.latitude || undefined,
            longitude: data.longitude || undefined,
            region: data.region || undefined,
            timezone: data.timezone || undefined,
            org: data.org || undefined,
          }
          setGeo(geoData)
          sessionStorage.setItem('belo_geo', JSON.stringify(geoData))
        }
      })
      .catch(() => {
        // Silently fail — badge just won't show
      })
      .finally(() => setLoading(false))

    return () => controller.abort()
  }, [])

  return { geo, loading }
}
